import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { GB } from './GB';
import { IE } from './IE';

i18n.use(initReactI18next).init({
  resources: {
    GB,
    IE,
  },
  fallbackLng: 'GB',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
